export const DEFAULT_SCRIPT = `/** @return {FormulaResult|Number|Array|Boolean|String} */
function process() {
    // input available in "context" variable
    return 1;
}
`;
